export default {"src":"/_next/static/media/light-bulb.591aa2ab.svg","height":181,"width":181};